import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import type { RowRenderProps } from 'react-table';

import type { Breadcrumb } from '@feathr/blackbox';
import { AvatarV2 as Avatar } from '@feathr/components';
import PersonName from '@feathr/extender/components/PersonName';
import { useStore } from '@feathr/extender/state';

import * as styles from './PersonCell.css';

interface IRow extends RowRenderProps {
  original: Breadcrumb;
}

function PersonCell({ original }: IRow): JSX.Element {
  const { Persons } = useStore();
  if (original.get('per_id')) {
    const person = Persons.get(original.get('per_id'));
    if (person && !person.isPending) {
      return (
        <>
          <Avatar name={person.get('name')} placeholder={person.get('placeholder')} />
          <div className={styles.stackedCellContent}>
            <PersonName hasLink={true} person={person.toJS()} />
            {person.get('external_id') && (
              <span className={styles.secondaryText}>{person.get('external_id')}</span>
            )}
          </div>
        </>
      );
    }
  }
  return <>Anonymous</>;
}

export default observer(PersonCell);
